<template>
  <v-container v-if="formulacion !== null" grid-list-xl>
    <br />
    <v-toolbar flat color="primary">
      <v-toolbar-title class="text-white">{{ formulacion.idnacionalNavigation.nombre }} -
        {{ formulacion.idperiodoNavigation.nombre }} - {{ this.gavancenacional.rangoperiodo }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon x-large v-on="on" @click="saveformulacion" :disabled="!puedesalvar">
              <v-icon color="white">save</v-icon>
            </v-btn>
          </template>
          <span>Guardar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon x-large color="white" @click="finalizarformulacion" v-on="on" :disabled="!puedesalvar">
              <v-icon>send</v-icon>
            </v-btn>
          </template>
          <span>Finalizar</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>
    <v-tabs show-arrows next-icon="fa-caret-right" prev-icon="fa-caret-left" background-color="blue-grey lighten-4"
      horizontal v-if="nacional !== null">
      <v-tabs-slider></v-tabs-slider>
      <v-tab>
        <v-icon left>folder</v-icon>Datos básicos
      </v-tab>
      <v-tab v-show="showcontrol('editaestrategia')">
        <v-icon left>work</v-icon>Estrategias
      </v-tab>
      <v-tab v-show="showcontrol('editafinanciamiento')">
        <v-icon left>local_atm</v-icon>Presupuesto
      </v-tab>
      <v-tab v-show="showcontrol('editainforme')">
        <v-icon left>attach_file</v-icon>Informe
      </v-tab>
      <v-tab>
        <v-icon left>fa-address-card</v-icon>Étnicos
      </v-tab>
      <v-tab>
        <v-icon left>history</v-icon>Histórico
      </v-tab>
      <v-tab-item>
        <v-card flat :loading="salvando">
          <v-card-title></v-card-title>
          <v-card-text>
            <v-flex sm12 xs12>
              <v-textarea v-model="nacional.objetivo" label="Objetivo:" :counter="1000" :readonly="true"></v-textarea>
            </v-flex>
            <v-flex sm12 xs12>
              <label style="font-size:11px;">Objetivos específicos:</label>
              <v-textarea style="margin-top:0px;margin-bottom:20px" v-html="nacional.especificos" :readonly="true"
                :counter="2000"></v-textarea>
            </v-flex>
            <v-row>
              <v-col>
                <v-text-field v-model="nacional.inicio" label="Fecha inicio:" :readonly="true" type="number" min="2017"
                  max="2050"></v-text-field>
              </v-col>

              <v-col>
                <v-text-field v-model="nacional.fin" label="Fecha fin:" type="number" :readonly="true" min="2017"
                  max="2050"></v-text-field>
              </v-col>
            </v-row>

            <v-flex xs12 sm12>
              <img width="240px" class="mx-auto d-block" v-bind:src="formulacion.idnacionalNavigation.imagen" />
            </v-flex>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card :loading="salvando">
          <v-card-title></v-card-title>
          <v-card-text>
            <v-data-table :headers="headerestrategia" :items="estrategias" class="elevation-1" :no-data-text="gnodata"
              :items-per-page="10">
              <template v-slot:[`item.textotareacantidad`]="{ item }">
                <v-badge color="orange" :content="item.textotareacantidad"></v-badge>
              </template>
              <template v-slot:[`item.textotareavalidadas`]="{ item }">
                <v-badge color="orange" :content="item.textotareavalidadas"></v-badge>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small class="mr-2" @click="grideditestrategia(item)"
                      v-scroll-to="'#containerc'">mdi-eye</v-icon>
                  </template>
                  <span v-if="puedeeditarestrategia">Ver</span>
                  <span v-else>Ver</span>
                </v-tooltip>
              </template>
            </v-data-table>
            <v-card v-if="frameestrategia" id="containerc" ref="containerc">
              <v-card-title>Seguimiento de estrategia - {{ estrategia.nombre }}</v-card-title>
              <v-card-text>
                <v-toolbar>
                  <v-toolbar-title>Lista de actividades</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table :headers="headeractividad" :items="actividades" class="elevation-1" :no-data-text="gnodata"
                  :items-per-page="10">
                  <template v-slot:[`item.idactividadNavigation.nombre`]="{ item }">
                    <v-badge v-if="item.ajustar === true" color="orange"
                      content="Ajustar">{{ item.idactividadNavigation.nombre }}</v-badge>
                    <v-badge v-if="item.ajustar === false" color="orange"
                      content="No ajustar">{{ item.idactividadNavigation.nombre }}</v-badge>
                    <p v-if="item.ajustar === null">{{ item.idactividadNavigation.nombre }}</p>
                  </template>
                  <template
                    v-slot:[`item.idactividadNavigation.fechacumplimiento`]="{ item }">{{ formato(item) }}</template>
                  <template v-slot:[`item.descripcion`]="{ item }">
                    <div v-html="item.descripcion"></div>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <div>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" small class="mr-2"
                            @click="grideditactividad(item)">{{ iconotabla(puedeeditarestrategia) }}</v-icon>
                        </template>
                        <span v-if="puedeeditarestrategia && puedesalvar">Editar</span>
                        <span v-else>Ver</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card :loading="salvando">
          <v-card-title></v-card-title>
          <v-card-text>
            <v-toolbar v-if="puedeeditarfinanciamiento && puedesalvar">
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon x-large v-on="on" @click="newpresupuesto">
                    <v-icon color="primary">add</v-icon>
                  </v-btn>
                </template>
                <span>Agregar</span>
              </v-tooltip>
            </v-toolbar>
            <v-dialog v-model="addfuentefinanciacion" width="800" persistent>
              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>Nuevo presupuesto</v-card-title>
                <v-card-text>
                  <br />
                  <form v-if="addfuentefinanciacion" data-vv-scope="form-nuevopresupuesto">
                    <v-row>
                      <v-col>
                        <v-select label="Punto: *" item-text="nombre" item-value="idpunto" value="idpunto"
                          :no-data-text="gnodata" :items="gpuntos" return-object v-model="punto"
                          v-validate="'required|financiamientounico'" data-vv-nav-validateme="punto"
                          data-vv-scope="form-nuevopresupuesto"
                          :error-messages="errors.collect('punto', 'form-nuevopresupuesto')"></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-select label="Pilar: *" :no-data-text="gnodata" item-text="nombrecompleto" :items="pilares"
                          return-object v-model="pilar" v-validate="'required|financiamientounico'" data-vv-name="pilar"
                          data-vv-scope="form-nuevopresupuesto"
                          :error-messages="errors.collect('pilar', 'form-nuevopresupuesto')"></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-select label="Fuente de financiamiento: *" :no-data-text="gnodata" item-text="nombre"
                          :items="gfuentes" return-object v-model="fuente" v-validate="'required|financiamientounico'"
                          data-vv-name="fuente" data-vv-scope="form-nuevopresupuesto"
                          :error-messages="errors.collect('fuente', 'form-nuevopresupuesto')"></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field label="Apropiación inicial:" type="number" min="1" max="1000000000000000"
                          data-vv-scope="form-nuevopresupuesto"
                          v-model="presupuesto.idfinanciamientoNavigation.apropiacion"></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field v-validate="'required|between:1,1000000000000000'" data-vv-name="vigente"
                          :error-messages="errors.collect('vigente', 'form-nuevopresupuesto')"
                          label="Apropiación vigente: *" v-model="presupuesto.vigente" type="number" min="1"
                          max="1000000000000000" data-vv-scope="form-nuevopresupuesto"></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field v-validate="validaobligacion" data-vv-name="obligacion"
                          :error-messages="errors.collect('obligacion', 'form-nuevopresupuesto')" label="Obligación: *"
                          v-model="presupuesto.obligacion" type="number" min="0" max="presupuesto.vigente"
                          data-vv-scope="form-nuevopresupuesto"></v-text-field>
                      </v-col>
                    </v-row>
                  </form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="addfuentefinanciacion = false">Cancelar</v-btn>
                  <v-btn color="primary" data-vv-scope="form-nuevopresupuesto" text
                    @click="preventguardarnuevopresupuesto">Aceptar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-data-table :headers="headerpresupuesto" :items="financiamientosavance" class="elevation-1"
              :no-data-text="gnodata" :items-per-page="10">
              <template v-slot:[`item.idfinanciamientoNavigation.apropiacion`]="{ item }">
                <div style="text-align: right">{{ moneda(item.idfinanciamientoNavigation.apropiacion) }}</div>
              </template>
              <template v-slot:[`item.vigente`]="{ item }">
                <div style="text-align: right">{{ moneda(item.vigente) }}</div>
              </template>
              <template v-slot:[`item.obligacion`]="{ item }">
                <div style="text-align: right">{{ moneda(item.obligacion) }}</div>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-layout row wrap v-if="puedeeditarfinanciamiento && puedesalvar">
                  <v-flex>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small @click="grideditpresupuesto(item)">edit</v-icon>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex v-if="item.idfinanciamiento == 0">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small @click="griddeletepresupuesto(item)">delete</v-icon>
                      </template>
                      <span>Eliminar</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card :loading="salvando">
          <v-card-title></v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-file-input :accept="formatoinforme" v-model="fileinforme" show-size label="Cargar archivo"
                  v-show="showcontrol('editainforme')" :disabled="readcontrol('editainforme')"
                  @change="onsoporteinformechange"></v-file-input>
              </v-col>
              <v-col>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="ma-2" @click="addsoporteinforme" :disabled="readcontrol('editainforme')"
                      v-show="showcontrol('editainforme')" tile outlined color="success">
                      <v-icon left>add</v-icon>Agregar
                    </v-btn>
                  </template>
                  <span>Agregar archivo</span>
                </v-tooltip>
                <v-tooltip top v-if="soporteinforme.length > 0">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="ma-2" @click="descargarsoporteinforme" tile outlined
                      v-show="showcontrol('editainforme')" color="success">
                      <v-icon left>mdi-eye</v-icon>Descargar
                    </v-btn>
                  </template>
                  <span>Descargar archivo</span>
                </v-tooltip>
                <p v-if="soporteinforme.length > 0">{{ soporteinforme[0].nombrearchivo }}</p>
              </v-col>
            </v-row>
            <v-flex>
              <v-card-text>
                <v-alert text elevation="2" border="left" color="primary" type="info" dismissible>
                  Recuerde que la información cargada es de carácter público, por lo tanto no se debe cargar información
                  clasificada, reservada (Ley 1712 de 2014) y/o con datos personales (Ley 1581 de 2012).
                </v-alert>
              </v-card-text>
              <br>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card :loading="salvando">
          <v-card-title></v-card-title>
          <v-card-text>
            <v-data-table :headers="headeretnicos" :items="cuestionarios" class="elevation-1" :no-data-text="gnodata"
              :items-per-page="100" hide-default-footer>
              <template v-slot:[`item.cantidad`]="{ item }">
                <v-badge :color="colorrespuesta(item.conteopreguntas - item.conteocontestadas)"
                  :content="item.textoavance">Cuestionario</v-badge>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small class="mr-2"
                      @click="grideditetnico(item)">{{ iconotabla(puedeeditarcuestionario) }}</v-icon>
                  </template>
                  <span v-if="puedeeditarcuestionario && puedesalvar">Editar</span>
                  <span v-else>Ver</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <historico :idtabla="20" :idelemento="gavancenacional.idavancenacional"></historico>
      </v-tab-item>
    </v-tabs>
    <v-flex xs12 sm12 v-show="showaprobacion('aprobado')">
      <v-card tile :loading="salvando">
        <v-toolbar flat dark color="primary">
          <v-toolbar-title>Revisión del seguimiento</v-toolbar-title>
          <div class="flex-grow-1"></div>
        </v-toolbar>
        <v-card-text>
          <v-flex xs12 sm12>
            <!-- <v-textarea
              v-validate="'max:4000'"
              data-vv-name="revisioncomentario"
              :error-messages="errors.collect('revisioncomentario')"
              :counter="4000"
              v-model="gavancenacional.comentarioflujo"
              label="Comentario:"
              :disabled="readcontrol('aprobado')"
            ></v-textarea> -->
            <label for="avancecualitativo" class="form-label">Comentario:</label>
            <quill-editor ref="revisioncomentario" id="revisioncomentario" v-model="gavancenacional.comentarioflujo"
              :options="editorOptionsRevisionComentario" :disabled="readcontrol('aprobado') == true"
              @ready="onEditorReady($event)" @change="onEditorChange($event)" />
            <div id="counter" class="counter"></div>
          </v-flex>
          <v-flex row>
            <v-flex xs6 sm6></v-flex>
            <v-flex xs6 sm6>
              <v-select :items="dropdown_comment" v-model="gavancenacional.aprobado" item-text="text" item-value="value"
                label="Seleccione opción"></v-select>
            </v-flex>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-speed-dial v-show="puedesalvar" fixed :bottom="true" :right="true" direction="left" :open-on-hover="true"
      transition="scale-transition">
      <template v-slot:activator>
        <v-btn fab color="blue-grey lighten-3">
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <v-btn id="btnp1" fab dark small color="green" @click="finalizarformulacion">
        <v-icon>send</v-icon>
      </v-btn>
      <v-btn fab dark small color="green" @click="saveformulacion">
        <v-icon>save</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-dialog v-model="editpresupuesto" width="800" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Edición de presupuesto</v-card-title>
        <v-card-text>
          <br />
          <form v-if="editpresupuesto" data-vv-scope="form-presupuesto">
            <v-row>
              <v-col>
                <v-text-field label="Punto:" v-model="presupuesto.idfinanciamientoNavigation.nombrepunto"
                  readonly></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field label="Pilar:" v-model="presupuesto.idfinanciamientoNavigation.nombrepilar"
                  readonly></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field label="Fuente de financiamiento:"
                  v-model="presupuesto.idfinanciamientoNavigation.nombrefuente" readonly></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field v-model="presupuesto.idfinanciamientoNavigation.apropiacion" label="Apropiación inicial:"
                  type="number" min="1" max="1000000000000000" readonly></v-text-field>
              </v-col>
              <v-col>
                <v-text-field v-validate="'required|between:1,1000000000000000'" data-vv-name="vigente"
                  :error-messages="errors.collect('vigente')" v-model="presupuesto.vigente" label="Apropiación vigente: *"
                  type="number" min="1" max="1000000000000000"></v-text-field>
              </v-col>
              <v-col>
                <v-text-field v-validate="validaobligacion" data-vv-name="obligacion"
                  :error-messages="errors.collect('obligacion')" v-model="presupuesto.obligacion" label="Obligación: *"
                  type="number" min="0" max="presupuesto.vigente"></v-text-field>
              </v-col>
            </v-row>
          </form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="editpresupuesto = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="preventguardarpresupuesto">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editactividad" width="800" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Seguimiento de actividad</v-card-title>
        <v-card-text>
          <br />
          <form v-if="editactividad" data-vv-scope="form-actividad">
            <v-row>
              <v-col>
                <v-textarea v-model="actividad.idactividadNavigation.nombre" label="Actividad:" readonly
                  :counter="1000"></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field v-model="actividad.idactividadNavigation.ponderacion" label="Ponderación:" type="number"
                  min="1" max="100" readonly></v-text-field>
              </v-col>
              <v-col>
                <v-text-field v-model="fechaformato" label="Fecha estimada de cumplimiento:" readonly></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                 <!-- <v-textarea
                  v-model="actividad.descripcion"
                  label="Avance: *"
                  v-validate="'required|max:1200'"
                  :counter="1200"
                  data-vv-name="actividad"
                  :error-messages="errors.collect('actividad')"
                  :readonly="!puedeeditarestrategia"
                ></v-textarea>  -->
                <label style="font-size:11px;">Avance: *</label>
                <quill-editor id="actividad" ref="actividad"
                  :disabled="(puedeeditarestrategia == false) || (readcontrol('aprobado') == true)"
                  v-model="actividad.descripcion" :error-messages="errors.collect('actividad')"
                  :options="editorOptionsActividad" @ready="onEditorReady($event)" @change="onEditorChange($event)" />
                <div id="counter2" class="counter"></div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-radio-group row v-validate="'required'" label="Cumplido: *" v-model="actividad.cumplido"
                  data-vv-name="cumplido" :error-messages="errors.collect('cumplido')"
                  :readonly="!puedeeditarestrategia || !puedesalvar">
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col v-if="actividad.cumplido && (!puedeeditarestrategia || !puedesalvar)">
                <v-text-field v-model="fechaformato2" label="Fecha real de cumplimiento: *" readonly></v-text-field>
              </v-col>
              <v-col v-if="actividad.cumplido && puedeeditarestrategia && puedesalvar">
                <v-menu v-model="menu3" :close-on-content-click="false" transition="scale-transition" offset-y
                  max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="fechaformato2" label="Fecha real de cumplimiento: *" prepend-icon="event"
                      readonly v-validate="validacionfecha" data-vv-name="fechareal"
                      :error-messages="errors.collect('fechareal')" v-on="on"></v-text-field>
                  </template>
                  <v-row justify="space-around">
                    <v-date-picker v-model="fechareal" no-title @input="menu3 = false" locale="es"
                      scrollable></v-date-picker>
                  </v-row>
                </v-menu>
              </v-col>
            </v-row>

            <v-row v-if="actividad.cumplido">
              <v-col>
                <template>
                  <v-file-input accept=".pdf, .xlsx, .xls" v-model="fileactividad" show-size label="Cargar archivo"
                    multiple :disabled="readcontrol('soporteactividad')" v-show="showcontrol('soporteactividad')"
                    @change="onsoportechange"></v-file-input>
                </template>
              </v-col>
              <v-col>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="ma-2" @click="addsoporteactividad" :disabled="readcontrol('soporteactividad')"
                      v-show="showcontrol('soporteactividad')" tile outlined color="success">
                      <v-icon left>add</v-icon>Agregar
                    </v-btn>
                  </template>
                  <span>Agregar archivo</span>
                </v-tooltip>
              </v-col>
            </v-row>

            <v-row v-if="actividad.cumplido">
              <v-col>
                <v-data-table :headers="headersoporte" :items="soportesactividad" class="elevation-1"
                  :items-per-page="100" hide-default-footer :no-data-text="gnodata">
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small class="mr-2" @click="deletesoporteactividad(item)"
                          :disabled="readcontrol('soporteactividad')">delete</v-icon>
                      </template>
                      <span>Eliminar</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small class="mr-2" @click="descargarsoporteactividad(item)">mdi-file</v-icon>
                      </template>
                      <span>Descargar</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-radio-group row v-model="actividad.ajustar"
                  label="¿Determina que el registro de actividad requiere ajustes?:"
                  :readonly="readcontrol('revisionactividad')" v-show="showcontrol('revisionactividad')">
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="editactividad = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="preventguardaractividad">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editacuestionario" width="800" persistent>
      <v-card v-if="editacuestionario === true">
        <v-card-title class="headline grey lighten-2" primary-title>Cuestionario -
          ({{ cuestionario.idindicadorNavigation.codigo }}) {{ cuestionario.idindicadorNavigation.nombre }}</v-card-title>
        <v-card-text>
          <br />
          <form data-vv-scope="form-cuestionario">
            <v-row v-for="n in respuestas" :key="`${n.idrespuesta}-pregunta`">
              <v-col :cols="4">{{ n.idpreguntaNavigation.orden }}. {{ n.idpreguntaNavigation.nombre }}</v-col>
              <v-col :cols="8">
                <v-textarea v-if="n.idpreguntaNavigation.idtipopregunta === 1" label v-model="n.descripcion"
                  :readonly="readcontrol('etnicos')" data-vv-name="textoetnico"
                  :error-messages="errors.collect('textoetnico')" v-validate="'max:4000'" :counter="4000"></v-textarea>
                <v-radio-group row label v-model="n.sino" :readonly="readcontrol('etnicos')"
                  v-if="n.idpreguntaNavigation.idtipopregunta === 2" data-vv-name="textoetnico">
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
                <v-text-field v-if="n.idpreguntaNavigation.idtipopregunta === 3" label @keydown="tecla($event)"
                  v-model="n.descripcion" :readonly="readcontrol('etnicos')" type="number" min="0"
                  max="1000000000"></v-text-field>
              </v-col>
              <p>&nbsp;</p>
              <v-divider></v-divider>
            </v-row>
          </form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="editacuestionario = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="guardarcuestionario">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snack" :timeout="timeoutsnak" top elevation="20" :color="MesaggeInfo.color">
      {{ this.MesaggeInfo.codigoRespuesta }}
      {{ this.MesaggeInfo.mensajeRespuesta }}
      <v-btn text @click="functionalert">{{ buttontext }}</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import historico from "../../components/content/historico";
import store from "../../stores/index.js";
import estrategia from "../../stores/_estrategia";
import { ErrorBag } from 'vee-validate';

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import { quillEditor } from 'vue-quill-editor'
import Counter from "../../components/global/counter.js";
import Quill from 'quill';
var Delta = Quill.import('delta');
Quill.register('modules/counter', Counter);

export default {
  name: "formulacion",
  data() {
    return {
      punto: {},
      pilares: [],
      pilar: {},
      fuente: {},
      financiamientosavance: [],
      formulacion: null,
      nacional: null,
      estrategias: [],
      presupuestos: [],
      estrategia: null,
      frameestrategia: false,
      menu2: false,
      menu3: false,
      actividad: { nombre: "" },
      presupuesto: {},
      editactividad: false,
      nuevaactividad: false,
      indexestrategia: 0,
      indexactividad: 0,
      addfuentefinanciacion: false,
      editpresupuesto: false,
      nuevopresupuesto: false,
      dialogpresupuesto: false,
      puedeeditarestrategia: false,
      puedeeditarfinanciamiento: false,
      estadocampos: [],
      salvando: false,
      permisosalvar: false,
      dialog: false,
      fecha: new Date().toISOString().substr(0, 10),
      fechareal: new Date().toISOString().substr(0, 10),
      fechaformato: null,
      fechaformato2: null,
      fileactividad: null,
      tamanoarchivo: null,
      tamanopaquete: null,
      tiposarchivo: null,
      buttontext: "Cerrar",
      validacionfecha: "",
      dropdown_comment: [
        { text: "Aprobar", value: true },
        { text: "Rechazar", value: false },
      ],
      headerestrategia: [],
      headersoporte: [
        {
          text: "Nombre archivo",
          value: "nombrearchivo",
          align: "center",
          width: "90%",
        },
        { text: "Acciones", value: "action", sortable: false, width: "10%" },
      ],
      headeractividad: [
        {
          text: "Actividad",
          value: "nombre",
          align: "rigth",
        },
        {
          text: "Ponderación",
          value: "idactividadNavigation.ponderacion",
          align: "center",
          width: 200,
        },
        {
          text: "Fecha de cumplimiento",
          value: "idactividadNavigation.fechacumplimiento",
          align: "center",
        },
        {
          text: "Avance",
          value: "descripcion",
          align: "rigth",
        },
        {
          text: "Acción",
          value: "action",
          sortable: false,
          width: 100,
          align: "center",
        },
      ],
      headeretnicos: [
        {
          text: "Código",
          value: "idindicadorNavigation.codigo",
          align: "left",
          sortable: false,
          width: "10%",
        },
        {
          text: "Indicador",
          value: "idindicadorNavigation.nombre",
          align: "left",
          sortable: false,
          width: "80%",
        },
        {
          text: "Cuestionario",
          value: "cantidad",
          align: "left",
          sortable: false,
          width: "10%",
        },
        {
          text: "Acción",
          value: "action",
          sortable: false,
          width: 100,
          align: "center",
        },
      ],
      headerpresupuesto: [
        {
          text: "Punto",
          value: "idfinanciamientoNavigation.nombrepunto",
          align: "left",
          width: "20%",
        },
        {
          text: "Pilar",
          value: "idfinanciamientoNavigation.nombrepilar",
          align: "left",
          width: "20%",
        },
        {
          text: "Fuente de financiación",
          value: "idfinanciamientoNavigation.nombrefuente",
          align: "left",
          width: "20%",
        },
        {
          text: "Apropiación inicial",
          value: "idfinanciamientoNavigation.apropiacion",
          align: "right",
        },
        {
          text: "Apropiación vigente",
          value: "vigente",
          align: "right",
        },
        {
          text: "Obligación",
          value: "obligacion",
          align: "right",
        },
        {
          text: "Acción",
          value: "action",
          sortable: false,
          width: 100,
          align: "center",
        },
      ],
      imageUrl: [],
      soportes: [],
      //errores
      snack: false,
      timeoutsnak: 4000,
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      //Validacion de campos
      dictionary: {
        custom: {
          actividad: {
            required: () => "El avance de la actividad es obligatoria",
            max: "Está superando el límite de caracteres",
          },
          cumplido: {
            required: () => "La especificación de cumplido es obligatoria",
          },
          ponderado: {
            required: () => "La ponderación de la actividad es obligatoria",
            between: () =>
              "El valor de ponderación debe estar en un rango entre 1 y 100",
            numeric: () =>
              "La ponderación solamente tiene en cuenta número enteros",
          },
          fechacumplimiento: {
            required: () =>
              "La fecha de cumplimineto de la actividad es obligatoria",
          },
          fechareal: {
            required: () =>
              "La fecha real de cumplimiento de la actividad es obligatoria",
            date_between: () => this.mensajevalidacionfecha,
          },
          revisioncomentario: {
            max: "Está superando el límite de caracteres",
          },
          punto: {
            required: () => "El punto del presupuesto es obligatorio",
          },
          pilar: {
            required: () => "El pilar del presupuesto es obligatorio",
          },
          fuente: {
            required: () => "La fuente de financiamiento es obligatoria",
          },
          vigente: {
            required: () => "El valor de la apropiación vigente es obligatorio",
            between: () =>
              "El valor de apropiación vigente debe estar en un rango entre 1 y 1.000.000.000.000.000",
          },
          obligacion: {
            required: () => "El valor de la obligación es obligatorio",
            between: () => this.errorobligacion,
          },
          textoetnico: {
            required: () => "La respuesta es obligatoria",
          },
        },
      },

      formatoinforme: "",
      extensioninforme: "",
      fileinforme: "",
      informeurl: null,

      cuestionarios: [],
      cuestionario: null,
      indexcuestionario: null,
      indexpregunta: null,
      editacuestionario: false,
      respuestas: [],
      quill: null,
      editorOptionsRevisionComentario: {
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
            ],
          },
          counter: {
            container: '#counter',
            controlContainer: '#revisioncomentario',
            unit: 'letra',
            max: 8000
          },
          clipboard: {
            matchers: [
              [Node.ELEMENT_NODE, function (node, delta) {
                return delta.compose(new Delta().retain(delta.length(),
                  {
                    align: "justify",
                    link: false,
                    color: false,
                    size: "10px",
                    header: false
                  }
                ));
              }
              ]
            ]
          }
        },
        placeholder: ''
      },
      editorOptionsActividad: {
        theme: 'snow',
        readOnly: true,
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
            ],
          },
          counter: {
            container: '#counter2',
            controlContainer: '#actividad',
            unit: 'letra',
            max: 1200
          },
          clipboard: {
            matchers: [
              [Node.ELEMENT_NODE, function (node, delta) {
                return delta.compose(new Delta().retain(delta.length(),
                  {
                    align: "justify",
                    link: false,
                    color: false,
                    size: "10px",
                    header: false
                  }
                ));
              }
              ]
            ]
          }
        },
        placeholder: ''
      }
    };
  },

  created() {
    let user = this.getusuario();
    let auten = user.token.replace("Bearer ", "");
    this.$aes.setKey(auten);
    let temporal = this.$route.params.idavancenacional.replace(/AbcYq/g, "/");
    temporal = temporal.replace(/qYcbA/g, "+");
    temporal = this.$aes.decrypt(temporal);
    temporal = temporal.substring(4);
    temporal = temporal.substring(0, temporal.length - 4);
    temporal = this.$aes.decrypt(temporal);
    let id = temporal;
    this.get_indicadoresreducido();
    this.cargaravances(id);
    this.get_configuraciones();
    this.get_controlespresentacion();
    this.get_puntos();
    this.get_pilares();
    this.get_fuentes();
  },
  components: {
    historico,
    quillEditor
  },
  $_veeValidate: {
    validator: "new",
  },
  mounted() {
    this.$validator.localize("es", this.dictionary);

    const FinanciamientoUnico = (value, args) =>
      new Promise((resolve) => {
        setTimeout(() => {
          this.get_existefinanciamientoavance({
            params: {
              idpilar: this.pilar.idpilar,
              idfuente: this.fuente.idfuente,
              idnacionalformulacion: this.gavancenacional.idnacionalformulacion,
            },
          }).then(value => {
            if (!this.gexistefinanciamientosavance && !this.existepresupuestosinguardar()) {
              return resolve({
                valid: true,
              });
            }

            return resolve({
              valid: false,
              data: {
                message: `El financiamiento con la combinación que intenta ingresar ya existe`,
              },
            });
          });


        }, 200);
      });

    this.$validator.extend("financiamientounico", {
      validate: FinanciamientoUnico,
      getMessage: (field, params, data) => data.message,
    });
  },
  computed: {
    ...mapGetters([
      "gnacionalformulacion",
      "gnacional",
      "gcampos",
      "gactividadesavance",
      "gavancenacional",
      "gsoportes",
      "gconfiguraciones",
      "gfinanciamientosavance",
      "gcontrolespresentacion",
      "gcuestionarios",
      "grespuestas",
      "gindicadoresreducido",
      "gpuntos",
      "gpilares",
      "gfuentes",
      "gexistefinanciamientosavance"
    ]),
    ...mapGetters("mensaje", [
      "ginformation",
      "gnodata",
      "glogo",
      "glogodnp",
      "gnosearch",
    ]),
    ...mapGetters("carga", ["gerrorcarga"]),
    validaobligacion() {
      return "required|between:0," + this.presupuesto.vigente;
    },
    errorobligacion() {
      return (
        "El valor de obligación debe estar en un rango entre 0 y " +
        this.presupuesto.vigente
      );
    },
    soporteinforme() {
      let temp = this.soportes.filter((p) => p.idavance == 0);
      return temp;
    },
    soportesactividad() {
      return this.soportes.filter(
        (p) => p.idavance === this.actividad.idactividadavance
      );
    },
    puedesalvar() {
      return !this.salvando && this.permisosalvar === true;
    },
    actividades() {
      if (this.puedesalvar) {
        return this.gactividadesavance.filter(
          (p) => p.idactividadNavigation != null && 
          p.idactividadNavigation.idestrategianacional ===
            this.estrategia.idestrategianacional &&
            p.idactividadNavigation.cumplido !== true
        );
      }
      else {
        return this.gactividadesavance.filter(
          (p) => p.idactividadNavigation != null &&
            p.idactividadNavigation.idestrategianacional ===
            this.estrategia.idestrategianacional
        );
      }
    },
    itemsporpagina2() {
      if (!isNaN(this.itemsPerPageSopCuan2)) return this.itemsPerPageSopCuan2;
      else return 1;
    },
    itemsporpagina3() {
      if (!isNaN(this.itemsPerPageSopCuan3)) return this.itemsPerPageSopCuan3;
      else return 1;
    },
    itemsporpagina4() {
      if (!isNaN(this.itemsPerPageSopCuan4)) return this.itemsPerPageSopCuan4;
      else return 1;
    },
  },
  methods: {
    ...mapActions([
      "get_nacionalformulacion",
      "put_avancenacional",
      "get_nacional",
      "get_camposestado",
      "get_actividadavancebyavance",
      "get_avancenacional",
      "get_soportesbyavancenacional",
      "get_configuraciones",
      "get_soporte_download",
      "get_financiamientoavancebyformulacion",
      "get_controlespresentacion",
      "get_respuestasbyavance",
      "get_cuestionariosbyavancenacional",
      "get_indicadoresreducido",
      "get_puntos",
      "get_pilares",
      "get_fuentes",
      "get_existefinanciamientoavance"
    ]),
    ...mapActions("carga/", ["post_cargararchivote"]),
    onEditorReady(quill) {
      quill.format('align', 'justify');
    },
    ocultarVentanaNuevoPresupuesto() {
      this.addfuentefinanciacion = false;
    },
    onEditorChange({ quill }) {
      quill.getModule('counter').update();
    },
    obligacionentera(item) {
      return int.parse(item.apropiacion);
    },
    tecla(event) {
      if (
        event.keyCode === 69 ||
        event.keyCode === 101 ||
        event.keyCode === 43 ||
        event.keyCode === 107 ||
        event.keyCode === 188 ||
        event.keyCode === 190 ||
        event.keyCode === 109
      ) {
        event.preventDefault();
      } else {
        false;
      }
    },
    iconotabla(variable) {
      if (variable && this.puedesalvar) {
        return "edit";
      } else {
        return "mdi-eye";
      }
    },
    colorrespuesta(numero) {
      if (numero === 0) return "green";
      else return "red";
    },
    cargaravances(id) {
      this.get_avancenacional({
        params: {
          idavancenacional: id,
        },
      });
      this.get_cuestionariosbyavancenacional({
        params: {
          idavancenacional: id,
        },
      });
      this.get_respuestasbyavance({
        params: {
          idavancenacional: id,
        },
      });
      this.get_actividadavancebyavance({
        params: {
          idavancenacional: id,
        },
      });
      this.get_soportesbyavancenacional({
        params: {
          idavancenacional: id,
        },
      });
    },
    addsoporteinforme() {
      if (this.fileinforme !== null) {
        let file = this.fileinforme;
        let soportet = {};
        soportet.nombrearchivo = file.name;
        soportet.tipoarchivo = file.type;
        soportet.idavance = 0;
        soportet.finalizado = false;
        soportet.archivocompleto = this.informeurl;
        soportet.idsoporte = 0;
        soportet.idactividadavance = 0;
        soportet.publico = true;
        let existe = this.soportes.filter((p) => p.idavance === 0)[0];
        if (existe !== undefined) {
          const index = this.soportes.indexOf(existe);
          this.soportes.splice(index, 1);
        }
        this.soportes.push(soportet);
        this.informeurl = null;
        this.fileinforme = null;
      } else {
        this.MesaggeInfo.mensajeRespuesta =
          "Seleccione un archivo para la carga";
        this.MesaggeInfo.color = "infovue";
        this.snack = true;
      }
    },
    addsoporteactividad() {
      if (this.fileactividad !== null) {
        for (let i = 0; i < this.fileactividad.length; i++) {
          let file = this.fileactividad[i];
          let soportet = {};
          soportet.nombrearchivo = file.name;
          soportet.tipoarchivo = file.type;
          soportet.idavance = this.actividad.idactividadavance;
          soportet.idactividadavance = this.actividad.idactividadavance;
          soportet.finalizado = false;
          soportet.archivocompleto = this.imageUrl[i];
          soportet.idsoporte = 0;
          this.soportes.push(soportet);
        }
        this.imageUrl = [];
        this.fileactividad = [];
      } else {
        this.MesaggeInfo.mensajeRespuesta =
          "Seleccione un archivo para la carga";
        this.MesaggeInfo.color = "infovue";
        this.snack = true;
      }
    },
    onsoporteinformechange() {
      this.informeurl = {};
      let error = false;
      if (this.fileinforme !== null) {
        let file = this.fileinforme;
        let tipo = file.type.replace("application/", "");
        if (this.extensioninforme.indexOf(tipo, 0) > 0) {
          if (file.size > this.tamanoarchivo * 1024000) {
            this.MesaggeInfo.mensajeRespuesta =
              "El tamaño de uno de los archivos supera el límite de carga (" +
              this.tamanoarchivo +
              "Mb)";
            this.MesaggeInfo.color = "errorvue";
            this.snack = true;
            error = true;
          } else {
            let reader = new FileReader();
            reader.onload = () => {
              this.informeurl = reader.result;
            };
            reader.readAsDataURL(file);
          }
        } else {
          this.MesaggeInfo.mensajeRespuesta =
            "Uno de los archivos no es compatible con los tipos permitidos";
          this.MesaggeInfo.color = "errorvue";
          this.snack = true;
          error = true;
        }
        if (error === true) {
          this.imageUrl = null;
          this.fileinforme = null;
        }
      }
    },
    onsoportechange() {
      this.imageUrl = [];
      let error = false;
      if (this.fileactividad !== null) {
        for (let i = 0; i < this.fileactividad.length; i++) {
          if (error === false) {
            let file = this.fileactividad[i];
            let tipo = file.type.replace("application/", "");
            if (this.tiposarchivo.indexOf(tipo, 0) > 0) {
              if (file.size > this.tamanoarchivo * 1024000) {
                this.MesaggeInfo.mensajeRespuesta =
                  "El tamaño de uno de los archivos supera el límite de carga (" +
                  this.tamanoarchivo +
                  "Mb)";
                this.MesaggeInfo.color = "errorvue";
                this.snack = true;
                error = true;
              } else {
                let actual = this.soportes.filter(
                  (p) =>
                    p.nombrearchivo === file.name &&
                    p.idactividadavance === this.actividad.idactividadavance
                )[0];
                if (actual === undefined) {
                  let reader = new FileReader();
                  reader.onload = () => {
                    this.imageUrl.push(reader.result);
                  };
                  reader.readAsDataURL(file);
                } else {
                  this.MesaggeInfo.mensajeRespuesta =
                    "Uno de los archivos ya se encuentra relacionado en el reporte";
                  this.MesaggeInfo.color = "errorvue";
                  this.snack = true;
                  error = true;
                }
              }
            } else {
              this.MesaggeInfo.mensajeRespuesta =
                "Uno de los archivos no es compatible con los tipos permitidos";
              this.MesaggeInfo.color = "errorvue";
              this.snack = true;
              error = true;
            }
          }
        }
        if (error === true) {
          this.imageUrl = [];
          this.fileactividad = [];
        }
      }
    },
    deletesoporteactividad(item) {
      const index = this.soportes.indexOf(item);
      if (confirm("¿Esta seguro de eliminar el soporte?")) {
        this.soportes.splice(index, 1);
      }
    },
    getusuario() {
      return JSON.parse(unescape(localStorage.usuario));
    },
    moneda(value) {
      const options2 = { style: "currency", currency: "COP" };
      const numberFormat2 = new Intl.NumberFormat("es-CO", options2);
      return numberFormat2.format(value.toFixed(0)).slice(0, -3);
    },
    formato(value) {
      if (value) {
        return moment(
          String(value.idactividadNavigation.fechacumplimiento)
        ).format("DD/MM/YYYY");
      }
    },
    formatofecha(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    async invocarsalvado() {
      this.salvando = true;
      this.gavancenacional.actividadavance = this.gactividadesavance;
      this.gavancenacional.financiamientoavance = this.gfinanciamientosavance;
      this.gavancenacional.soportesactividad = this.soportes;
      this.gavancenacional.respuesta = this.grespuestas;
      let bytes = window.crypto.getRandomValues(new Uint8Array(32));
      const randomBytes = () => (bytes = bytes.slice(1)) && bytes[0];
      let tran = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (c ^ (randomBytes() & (15 >> (c / 4)))).toString(16)
      );
      this.gavancenacional.transaccion = tran;
      let errorcarga = false;
      let nuevos = this.soportes.filter((p) => p.idsoporte === 0);
      console.log('salvando archivos ', nuevos)
      if (nuevos.length >= 1) {
        await this.post_cargararchivote({
          archivo: nuevos,
          idtransaccion: tran,
          tamanopaquete: this.tamanopaquete,
        }).then(function () { });
        errorcarga = this.gerrorcarga;
      }
      if (errorcarga === false) {
        this.put_avancenacional({ data: this.gavancenacional });
      } else {
        this.errortemporal();
      }
    },
    errortemporal() {
      this.snack = true;
      this.MesaggeInfo.mensajeRespuesta =
        "Existe una problema en el cargue de los archivos. Intente reducir el número de archivos a guardar.";
      this.MesaggeInfo.color = "warnvue";
      this.salvando = false;
    },
    saveformulacion() {
      this.ValidarRevisionComentario();
      this.$validator.validateAll().then((result) => {
        if (!result || this.$validator.errors.items.length > 0) {
          this.snack = true;
          this.snackalert = false;
          this.buttontext = "Cerrar";
          this.timeoutsnak = 4000;
          let Errores = "";

          this.$validator.errors.items.forEach((element) => {
            Errores = Errores + element.msg + "; ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "La validación del formulario contiene errores: " + Errores;
          this.MesaggeInfo.color = "infovue";
          this.$validator.errors.items = [];
          this.$validator.reset();
          console.log('this.$validator', this.$validator);
          return;
        } else {
          this.gavancenacional.finalizar = false;
          this.invocarsalvado();
        }
      });
    },
    ValidarRevisionComentario() {
      let bag = new ErrorBag();
      bag = this.errors;

      if (bag.first('revisioncomentario') !== undefined)
        bag.removeById(bag.first('revisioncomentario').id);

      if (this.$refs.revisioncomentario.quill.root.innerHTML.length > this.$refs.revisioncomentario.quill.options.modules.counter.max && bag.first('revisioncomentario') == undefined) {
        bag.add({
          field: 'revisioncomentario',
          msg: 'está superando el límite de caracteres'
        });
      }

      //revisioncomentario 
    },

    finalizarformulacion() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.snack = true;
          this.snackalert = false;
          this.buttontext = "Cerrar";
          this.timeoutsnak = 4000;
          let Errores = "";
          this.$validator.errors.items.forEach((element) => {
            Errores = Errores + element.msg + "; ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "La validación del formulario contiene errores: " + Errores;
          this.MesaggeInfo.color = "infovue";
          return;
        } else {
          let aprobar = this.showaprobacion("aprobado");
          if (
            aprobar &&
            (this.gavancenacional.comentarioflujo === null ||
              this.gavancenacional.aprobado === null)
          ) {
            this.snack = true;
            this.snackalert = false;
            this.timeoutsnak = 4000;
            this.MesaggeInfo.mensajeRespuesta =
              "Es obligatorio diligenciar los datos de revisión del seguimiento";
            this.MesaggeInfo.color = "infovue";
            return;
          }
          this.gavancenacional.finalizar = true;
          //Actualización de filtros para limpiar bandeja de tareas
          let sfiltrogeneral = localStorage.filtrogeneral;
          let filtrogeneral = [];
          if (sfiltrogeneral !== undefined) {
            filtrogeneral = JSON.parse(unescape(sfiltrogeneral));
          }
          let proceso = filtrogeneral.filter((p) => p.idproceso === 8)[0];
          if (proceso === undefined) {
            proceso = { idproceso: 8, arreglo: [] };
            filtrogeneral.push(proceso);
          }
          let arreglo = proceso.arreglo;
          arreglo.push({
            idelemento: this.gavancenacional.idavancenacional,
            fecha: new Date(),
          });
          localStorage.setItem("filtrogeneral", JSON.stringify(filtrogeneral));
          this.invocarsalvado();
        }
      });
    },
    guardarcuestionario() {
      this.$validator.validateAll("form-cuestionario").then((result) => {
        if (!result) {
          this.snack = true;
          this.snackalert = false;
          this.buttontext = "Cerrar";
          this.timeoutsnak = 6000;
          let Errores = "";
          this.MesaggeInfo.mensajeRespuesta =
            "La validación del formulario contiene errores, verifique que los textos no excedan el tamaño permitido.";
          this.MesaggeInfo.color = "infovue";
          return;
        } else {
          for (let i = 0; i < this.respuestas.length; i++) {
            let respuesta = this.respuestas[i];
            let original = this.grespuestas.filter(
              (p) => p.idrespuesta === respuesta.idrespuesta
            )[0];
            if (
              original.idpreguntaNavigation.idtipopregunta === 1 ||
              original.idpreguntaNavigation.idtipopregunta === 3
            ) {
              original.descripcion = respuesta.descripcion;
              if (respuesta.descripcion === "") {
                respuesta.descripcion = null;
              }
            } else {
              original.sino = respuesta.sino;
              if (respuesta.sino !== null)
                original.descripcion = respuesta.sino.toString();
            }
          }
          this.cuestionarios[
            this.indexcuestionario
          ].conteocontestadas = this.respuestas.filter(
            (p) =>
              (p.descripcion !== null && p.descripcion !== "") ||
              p.sino !== null
          ).length;
          let co = this.cuestionarios[this.indexcuestionario].conteocontestadas;
          this.cuestionarios[this.indexcuestionario].textoavance =
            this.cuestionarios[
              this.indexcuestionario
            ].conteopreguntas.toString() +
            " - " +
            co.toString();
          this.editacuestionario = false;
        }
      });
    },
    preventguardaractividad() {
      this.$validator.validateAll("form-actividad").then((result) => {
        if (!result || this.$refs.actividad.quill.root.innerHTML === '<p class="ql-align-justify"><br></p>' || this.$refs.actividad.quill.root.innerHTML.length > this.$refs.actividad.quill.options.modules.counter.max) {
          this.snack = true;
          this.snackalert = false;
          this.buttontext = "Cerrar";
          this.timeoutsnak = 6000;
          let Errores = "";

          let bag = new ErrorBag();
          bag = this.errors;
          if (bag.first('actividad', 'form-actividad') !== undefined)
            bag.removeById(bag.first('actividad', 'form-actividad').id);

          if (this.$refs.actividad.quill.root.innerHTML === '<p class="ql-align-justify"><br></p>' && bag.first('actividad', 'form-actividad') == undefined) {
            bag.add({
              scope: 'form-actividad',
              field: 'actividad',
              msg: 'El avance de la actividad es obligatoria'
            });
          }

          if (bag.first('actividad') !== undefined)
            bag.removeById(bag.first('actividad').id);

          if (this.$refs.actividad.quill.root.innerHTML.length > this.$refs.actividad.quill.options.modules.counter.max && bag.first('actividad') == undefined) {
            bag.add({
              field: 'actividad',
              msg: 'está superando el límite de caracteres'
            });
          }

          this.$validator.errors.items.forEach((element) => {
            Errores = Errores + " " + element.msg + ",";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "La validación del formulario contiene errores: " +
            Errores.slice(0, -1);
          this.MesaggeInfo.color = "infovue";
          return;
        } else {
          this.$validator.errors.items = [];
          this.$validator.reset();
          this.salvarexistenteactividad();
        }
      });
    },
    preventguardarpresupuesto() {
      this.$validator.validateAll("form-presupuesto").then((result) => {
        if (!result) {
          this.snack = true;
          this.snackalert = false;
          this.buttontext = "Cerrar";
          this.timeoutsnak = 6000;
          let Errores = "";
          this.$validator.errors.items.forEach((element) => {
            Errores = Errores + "( " + element.msg + " ), ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "La validación del formulario contiene errores " + Errores;
          this.MesaggeInfo.color = "infovue";
          return;
        } else {

          this.presupuesto.idfinanciamientoNavigation.apropiacion = parseFloat(this.presupuesto.idfinanciamientoNavigation.apropiacion);
          this.presupuesto.vigente = parseFloat(this.presupuesto.vigente);
          this.presupuesto.obligacion = parseFloat(this.presupuesto.obligacion);
          this.salvarexistentepresupuesto();
        }
      });
    },
    preventguardarnuevopresupuesto() {
      this.$validator.validateAll("form-nuevopresupuesto").then((result) => {
        if (!result) {
          this.snack = true;
          this.snackalert = false;
          this.buttontext = "cerrar";
          this.timeoutsnak = 4000;
          let Errores = "";
          this.$validator.errors.items.forEach((element) => {
            if (element.scope == "form-nuevopresupuesto")
              Errores = Errores + element.msg + "; ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "La validación del formulario contiene errores: " + Errores;
          this.MesaggeInfo.color = "infovue";
          return;
        } else {
          this.presupuesto.idnacionalformulacion = this.gavancenacional.idnacionalformulacion;
          this.presupuesto.idavancenacional = this.gavancenacional.idavancenacional;
          this.presupuesto.idfinanciamientoNavigation.idnacionalformulacion = this.gavancenacional.idnacionalformulacion;
          this.presupuesto.idfinanciamientoNavigation.idpunto = this.punto.idpunto;
          this.presupuesto.idfinanciamientoNavigation.nombrepunto = this.punto.nombrecompleto;
          this.presupuesto.idfinanciamientoNavigation.idpilar = this.pilar.idpilar;
          this.presupuesto.idfinanciamientoNavigation.nombrepilar = this.pilar.nombrecompleto;
          this.presupuesto.idfinanciamientoNavigation.idfuente = this.fuente.idfuente;
          this.presupuesto.idfinanciamientoNavigation.nombrefuente = this.fuente.nombre;
          this.presupuesto.idfinanciamientoNavigation.apropiacion = parseFloat(
            this.presupuesto.idfinanciamientoNavigation.apropiacion
          );
          this.presupuesto.vigente = parseFloat(this.presupuesto.vigente);
          this.presupuesto.obligacion = parseFloat(this.presupuesto.obligacion);
          if (this.nuevopresupuesto === true) {
            this.salvarnuevopresupuesto();
          } else {
            this.salvarexistentepresupuesto();
          }
        }
      });
    },
    salvarnuevopresupuesto() {
      this.financiamientosavance.push(this.presupuesto);
      Object.assign(this.gfinanciamientosavance, this.financiamientosavance);
      // this.gfinanciamientosavance =  this.financiamientosavance;
      this.addfuentefinanciacion = false;

    },
    salvarexistentepresupuesto() {
      this.gfinanciamientosavance[
        this.indexpresupuesto
      ].idfinanciamientoNavigation.apropiacion = this.presupuesto.idfinanciamientoNavigation.apropiacion;
      this.gfinanciamientosavance[
        this.indexpresupuesto
      ].vigente = this.presupuesto.vigente;
      this.gfinanciamientosavance[
        this.indexpresupuesto
      ].obligacion = this.presupuesto.obligacion;
      this.editpresupuesto = false;
    },
    salvarexistenteactividad() {
      this.gactividadesavance[
        this.indexactividad
      ].descripcion = this.actividad.descripcion;
      this.gactividadesavance[
        this.indexactividad
      ].cumplido = this.actividad.cumplido;
      this.editactividad = false;
      this.gactividadesavance[
        this.indexactividad
      ].ajustar = this.actividad.ajustar;
      this.editactividad = false;
      if (this.actividad.cumplido === true) {
        this.gactividadesavance[this.indexactividad].fechareal = this.fechareal;
      }
      let estrategia = this.estrategias.filter(
        (p) =>
          p.idestrategianacional ===
          this.actividad.idactividadNavigation.idestrategianacional
      )[0];
      let actividades = this.gactividadesavance.filter(
        (p) =>
          (p.idactividadNavigation.cumplido === null ||
            p.idactividadNavigation.cumplido === false) &&
          p.idactividadNavigation.idestrategianacional ===
          estrategia.idestrategianacional
      );
      let registradas = actividades.filter(
        (p) => p.descripcion !== null && p.descripcion !== ""
      ).length;
      estrategia.textotareacantidad =
        registradas.toString() + " de " + actividades.length;
      let revisadas = actividades.filter(
        (p) =>
          p.descripcion !== null && p.descripcion !== "" && p.ajustar !== null
      ).length;
      estrategia.textotareavalidadas =
        revisadas.toString() + " de " + registradas.toString();
    },
    grideditetnico(item) {
      this.cuestionario = item;
      this.indexcuestionario = this.cuestionarios.indexOf(item);
      this.indexpregunta = 0;
      this.editacuestionario = true;
      this.respuestas = [];
      let temp = this.grespuestas.filter(
        (p) => p.idpreguntaNavigation.idcuestionario === item.idcuestionario
      );
      for (let index = 0; index < temp.length; index++) {
        let respuesta = temp[index];
        let tempo = {
          idrespuesta: respuesta.idrespuesta,
          descripcion: respuesta.descripcion,
          idpreguntaNavigation: respuesta.idpreguntaNavigation,
          sino: null,
        };
        if (respuesta.descripcion === null) {
          tempo.sino = null;
        }
        if (
          respuesta.descripcion === "true" ||
          respuesta.descripcion === "false"
        ) {
          tempo.sino = respuesta.descripcion === "true";
        }
        this.respuestas.push(tempo);
      }
    },
    grideditpresupuesto(item) {
      this.presupuesto = {
        idfinanciamientoNavigation: item.idfinanciamientoNavigation,
        vigente: item.vigente,
        obligacion: item.obligacion,
      };
      this.indexpresupuesto = this.gfinanciamientosavance.indexOf(item);
      this.editpresupuesto = true;
    },
    griddeletepresupuesto(item) {
      this.indexpresupuesto = this.gfinanciamientosavance.indexOf(item);
      this.financiamientosavance.splice(this.indexpresupuesto, 1);
    },
    grideditactividad(item) {
      this.actividad = {
        ponderacion: item.ponderacion,
        fechacumplimiento: item.fechacumplimiento,
        fechareal: item.fechareal,
        nombre: item.nombre,
        idestrategianacional: item.idestrategianacional,
        idactividadNavigation: item.idactividadNavigation,
        descripcion: item.descripcion,
        idactividadavance: item.idactividadavance,
        cumplido: item.cumplido,
        ajustar: item.ajustar,
      };
      this.indexactividad = this.gactividadesavance.indexOf(item);
      this.fechaformato = this.formatofecha(
        this.actividad.idactividadNavigation.fechacumplimiento
      );
      this.fechareal = item.fechareal;
      this.editactividad = true;
    },
    grideditestrategia(item) {
      this.estrategia = item;
      this.frameestrategia = true;
      this.indexestrategia = this.estrategias.indexOf(item);
    },
    coloractividad(valor) {
      if (valor === 0) return "red";
      else return "green";
    },
    colorponderado(valor) {
      if (valor !== 100) return "red";
      else return "green";
    },
    showaprobacion(control) {
      let mostrar = this.showcontrol(control);
      if (mostrar === true) {
        mostrar = this.permisosalvar;
      }
      return mostrar;
    },
    showcontrol(control) {
      if (this.estadocampos.length > 0) {
        let responsefound = this.estadocampos.filter(
          (p) => p.nombre == control
        );
        if (responsefound.length === 0) {
          return false;
        } else {
          return responsefound[0].visible;
        }
      }
    },
    readcontrol(control) {
      if (this.estadocampos.length > 0) {
        let responseread = this.estadocampos.find(function (element) {
          if (element.nombre == control) {
            return element;
          }
        });
        if (responseread == null) return true;
        else return responseread.lectura || !this.puedesalvar;
      }
    },
    functionalert() {
      if (this.buttontext == "Cerrar") {
        this.snack = false;
      }
      if (this.buttontext == "Aceptar") {
        this.buttontext == "Cerrar";
        this.snack = false;
        this.timeoutsnak = 4000;
        this.$router.push("/tareas");
      }
    },
    descargarsoporteinforme() {
      let item = this.soporteinforme[0];
      if (item.archivocompleto == null) {
        this.get_soporte_download({
          params: {
            idsoporte: item.idsoporte,
          },
        });
      } else {
        const a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);
        a.href = item.archivocompleto;
        a.setAttribute("download", item.nombrearchivo);
        a.click();
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      }
    },
    descargarsoporteactividad(item) {
      if (item.archivocompleto == null) {
        this.get_soporte_download({
          params: {
            idsoporte: item.idsoporte,
          },
        });
      } else {
        const a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);
        a.href = item.archivocompleto;
        a.setAttribute("download", item.nombrearchivo);
        a.click();
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      }
    },
    cargarrespuestas() {
      for (let index = 0; index < this.cuestionarios.length; index++) {
        let preguntas = this.grespuestas.filter(
          (p) =>
            p.idpreguntaNavigation.idcuestionario ===
            this.cuestionarios[index].idcuestionario
        );
        this.cuestionarios[index].conteopreguntas = preguntas.length;
        this.cuestionarios[index].conteocontestadas = preguntas.filter(
          (p) => p.descripcion !== null
        ).length;
        this.cuestionarios[index].textoavance =
          this.cuestionarios[index].conteopreguntas.toString() +
          " - " +
          this.cuestionarios[index].conteocontestadas.toString();
      }
    },
    newpresupuesto() {
      let idfinanciamientoNavigation = {
        nombrefuente: "",
        nombrepilar: "",
        nombrepunto: ""
      }
      this.presupuesto = {
        idfinanciamiento: 0,
        idfuente: 0,
        nombrefuente: "",
        nombrepilar: "",
        idfinanciamientoNavigation: idfinanciamientoNavigation
      };
      this.editpresupuesto = false;
      this.nuevopresupuesto = true;
      this.addfuentefinanciacion = true;
      this.punto = null;
      this.fuente = null;
      this.pilar = null;
    },
    existepresupuestosinguardar() {
      let filtro = {
        idpilar: this.pilar.idpilar !== null ? this.pilar.idpilar : 0,
        idfuente: this.fuente !== null ? this.fuente.idfuente : 0,
        idnacionalformulacion: this.gavancenacional.idnacionalformulacion
      };
      let existepresupuestolocal = this.financiamientosavance.filter(function (p) {
        return p.idfinanciamientoNavigation.idpilar === filtro.idpilar &&
          p.idfinanciamientoNavigation.idfuente === filtro.idfuente &&
          p.idfinanciamientoNavigation.idnacionalformulacion === filtro.idnacionalformulacion
      }, filtro).length > 0;
      return existepresupuestolocal;
    },
  },
  watch: {
    gfinanciamientosavance() {
      this.financiamientosavance = this.gfinanciamientosavance;
    },
    gavancenacional() {
      let fechacorte = this.gavancenacional.fechacortetexto;
      let fechainicio = this.gavancenacional.fechainiciotexto;
      this.validacionfecha =
        "required|date_format:dd/MM/yyyy|date_between:" +
        fechainicio +
        "," +
        fechacorte +
        ",true";
      this.mensajevalidacionfecha =
        "La Fecha real de cumplimiento debe estar dentro del periodo de reporte del plan de acción (" +
        fechainicio +
        ", " +
        fechacorte +
        ")";
      this.get_financiamientoavancebyformulacion({
        params: {
          idnacionalformulacion: this.gavancenacional.idnacionalformulacion,
        },
      });
      this.get_nacionalformulacion({
        params: {
          idnacionalformulacion: this.gavancenacional.idnacionalformulacion,
        },
      });
      let usuario = this.getusuario();
      this.permisosalvar = false;
      if (this.gavancenacional.idusuarioresponsable != undefined) {
        this.permisosalvar =
          usuario.idusuario === this.gavancenacional.idusuarioresponsable
            ? true
            : false;
      } else {
        let rolexiste = usuario.usuarioRol.filter(
          (p) => p.idrol === this.gavancenacional.idrolresponsable
        )[0];
        if (rolexiste !== undefined) {
          this.permisosalvar = true;
        }
      }
      this.get_camposestado({
        params: {
          idtabla: "avancenacional",
          idestado: this.gavancenacional.idestado,
        },
      });
    },
    gcampos() {
      this.estadocampos = this.gcampos;
      this.puedeeditarestrategia = !this.estadocampos.filter(
        (p) => p.nombre === "editaestrategia"
      )[0].lectura;
      this.puedeeditarfinanciamiento = !this.estadocampos.filter(
        (p) => p.nombre === "editafinanciamiento"
      )[0].lectura;
      this.puedeeditarcuestionario = !this.estadocampos.filter(
        (p) => p.nombre === "editacuestionario"
      )[0].lectura;
      this.headerestrategia = [];
      this.headerestrategia.push({
        text: "Estrategia",
        value: "nombre",
        align: "rigth",
      });
      if (this.puedeeditarestrategia === true) {
        this.headerestrategia.push({
          text: "Registro",
          value: "textotareacantidad",
          sortable: false,
          width: 50,
          align: "center",
        });
      } else {
        if (this.puedesalvar) {
          this.headerestrategia.push({
            text: "Validación",
            value: "textotareavalidadas",
            sortable: false,
            width: 50,
            align: "center",
          });
        }
      }
      this.headerestrategia.push({
        text: "Acción",
        value: "action",
        sortable: false,
        width: 100,
        align: "center",
      });
    },
    punto: function () {
      if (this.punto !== null) {
        this.pilares = this.gpilares.filter(
          (p) => p.idpunto === this.punto.idpunto
        );
      }
    },
    puntos: function () {
      if (this.punto !== null) {
        this.pilares = this.gpilares.filter(
          (p) => p.idpunto === this.punto.idpunto
        );
      }
    },
    gnacionalformulacion: function () {
      this.formulacion = this.gnacionalformulacion;
      for (let index = 0; index < this.formulacion.actividad.length; index++) {
        let actividadavance = this.gactividadesavance.filter(
          (p) => p.idactividad === this.formulacion.actividad[index].idactividad
        )[0];
        if (actividadavance !== undefined) {
          actividadavance.idactividadNavigation = this.formulacion.actividad[
            index
          ];
          actividadavance.nombre = actividadavance.idactividadNavigation.nombre;
        }
      }

      for (
        let index2 = 0;
        index2 < this.formulacion.financiamiento.length;
        index2++
      ) {
        let financiamientoavance = this.gfinanciamientosavance.filter(
          (p) =>
            p.idfinanciamiento ===
            this.formulacion.financiamiento[index2].idfinanciamiento
        )[0];
        if (financiamientoavance !== undefined) {
          financiamientoavance.idfinanciamientoNavigation = this.formulacion.financiamiento[
            index2
          ];
        }
      }
      this.get_nacional({
        params: {
          idnacional: this.formulacion.idnacionalNavigation.idnacional,
        },
      });
    },
    gnacional() {
      this.nacional = this.gnacional;
      this.estrategias = this.nacional.estrategiaNacional.filter(
        (p) => p.activo === true
      );
      for (let index = 0; index < this.estrategias.length; index++) {
        let estrategia = this.estrategias[index];
        let actividades = this.gactividadesavance.filter(
          (p) =>
            (p.idactividadNavigation.cumplido === null ||
              p.idactividadNavigation.cumplido === false) &&
            p.idactividadNavigation.idestrategianacional ===
            estrategia.idestrategianacional
        );
        let registradas = actividades.filter(
          (p) => p.descripcion !== null && p.descripcion !== ""
        ).length;
        estrategia.textotareacantidad =
          registradas.toString() + " de " + actividades.length;
        let revisadas = actividades.filter(
          (p) =>
            p.descripcion !== null && p.descripcion !== "" && p.ajustar !== null
        ).length;
        estrategia.textotareavalidadas =
          revisadas.toString() + " de " + registradas.toString();
      }
    },
    ginformation() {
      this.salvando = false;
      this.MesaggeInfo = this.ginformation;
      this.snack = true;
      if (this.MesaggeInfo.codigoRespuesta === "") {
        setTimeout(() => {
          let id = this.gavancenacional.idavancenacional;
          this.cargaravances(id);
        }, 1000);
        if (this.gavancenacional.finalizar === true) {
          this.buttontext = "Aceptar";
          this.timeoutsnak = 0;
          //this.puedesalvar = false;
          this.snack = true;
          this.MesaggeInfo.mensajeRespuesta =
            "El proceso de registro de avance ha finalizado; presione aceptar para continuar";
          this.MesaggeInfo.color = "infovue";
        }
      }
    },
    fechareal() {
      let e = this.formatofecha(this.fechareal);
      this.fechaformato2 = e;
    },
    gsoportes() {
      this.soportes = this.gsoportes;
      for (let index = 0; index < this.soportes.length; index++) {
        this.soportes[index].idavance = this.soportes[index].idactividadavance;
      }
    },
    gconfiguraciones() {
      this.tiposarchivo = this.gconfiguraciones.filter(
        (p) => p.codigo === "TiposArchivo"
      )[0].valor;
      this.tamanoarchivo = this.gconfiguraciones.filter(
        (p) => p.codigo === "TamanoArchivo"
      )[0].valor;
      this.tamanopaquete = this.gconfiguraciones.filter(
        (p) => p.codigo === "TamanoPaquete"
      )[0].valor;
    },
    gcontrolespresentacion() {
      let informe = this.gcontrolespresentacion.filter(
        (p) => p.codigo === "NALSEGUI"
      )[0];
      this.formatoinforme = informe.formatos;
      this.extensioninforme = informe.extensiones;
    },
    gindicadoresreducido() {
      if (this.cuestionarios.length !== 0) {
        for (let index = 0; index < this.cuestionarios.length; index++) {
          this.cuestionarios[
            index
          ].idindicadorNavigation = this.gindicadoresreducido.filter(
            (p) => p.idindicador === this.cuestionarios[index].idindicador
          )[0];
        }
      } else {
        store.watch(
          () => store.getters["gcuestionarios"],
          () => {
            for (let index = 0; index < this.cuestionarios.length; index++) {
              this.cuestionarios[
                index
              ].idindicadorNavigation = this.gindicadoresreducido.filter(
                (p) => p.idindicador === this.cuestionarios[index].idindicador
              )[0];
            }
          }
        );
      }
    },
    gcuestionarios() {
      this.cuestionarios = this.gcuestionarios;
      if (this.gindicadoresreducido !== null) {
        for (let index = 0; index < this.cuestionarios.length; index++) {
          this.cuestionarios[
            index
          ].idindicadorNavigation = this.gindicadoresreducido.filter(
            (p) => p.idindicador === this.cuestionarios[index].idindicador
          )[0];
        }
      }
      if (this.grespuestas.length > 0) {
        this.cargarrespuestas();
      } else {
        store.watch(
          () => store.getters["grespuestas"],
          () => {
            this.cargarrespuestas();
          }
        );
      }
    },
  },
};
</script>
<style></style>